<template>
  <li :class="$style.category_list_box_section_item">
    <AtomsConsumerLink @click="emit('update:itemUpdateFilter')">
      <div :class="$style.category_list_box_section_item_img_box">
        <AtomsConsumerImage
          v-if="!md"
          :src="spImgUrl"
          :alt="title"
          :width="160"
          :height="90"
          :class="$style.category_list_box_section_item_img"
        />
        <AtomsConsumerImage
          v-else
          :src="imgUrl"
          :alt="title"
          :width="338"
          :height="189"
          :class="$style.category_list_box_section_item_img"
        />
      </div>
      <div :class="$style.category_list_box_section_item_text">
        <p>{{ title }}</p>
        <AtomsConsumerImage src="/images/icon/arrow.svg" :alt="title" :width="10" :height="12" />
      </div>
    </AtomsConsumerLink>
  </li>
</template>

<script setup lang="ts">
defineProps<{
  imgUrl: string
  spImgUrl: string
  title: string
}>()

const emit = defineEmits<{
  (e: "update:itemUpdateFilter"): void
}>()

const { width: windowWidth } = useWindowSize()
const md = computed(() => windowWidth.value >= 768)
</script>

<style scoped module lang="scss">
.category_list_box_section_item {
  width: 10rem;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  @include md {
    width: calc(33% - 14px);
  }

  .category_list_box_section_item_img_box {
    height: 5.625rem;
    @include md {
      height: 11.875rem;
      border-radius: 5px;
      border: 2px solid $primary-20;
    }
    .category_list_box_section_item_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 3px;
    }
  }

  .category_list_box_section_item_text {
    margin-top: 0.1rem;
    display: flex;
    img {
      margin-left: 0.3rem;
    }
    p {
      font-size: $font-size-13;
      color: $btn-bg-primary;
      text-align: left;
    }
  }
}
</style>
